import { render, staticRenderFns } from "./serviceCompanyShare.vue?vue&type=template&id=57c2185a"
import script from "./serviceCompanyShare.vue?vue&type=script&lang=js"
export * from "./serviceCompanyShare.vue?vue&type=script&lang=js"
import style0 from "./serviceCompanyShare.vue?vue&type=style&index=0&id=57c2185a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports